<div [ngStyle]="{'display': displayLoader()}" class="ngx-fullpage-loader__overlay">
  <div class="ngx-fullpage-loader__custom-content" #customContent >
    <ng-content></ng-content>
  </div>

  @if (!customContent.innerHTML.trim()) {
    <mat-progress-spinner
      mode="indeterminate"
      class="ngx-fullpage-loader_spinner"
      diameter="35"
      strokeWidth="1"
      color="#122550">
    </mat-progress-spinner>
  }
</div>
